import React from "react";
import { Link } from "react-router-dom";

interface MoreButtonProps {
    path?: string;
}

const MoreButton: React.FC<MoreButtonProps> = ({ path = "/" }) => {
  return (
    <Link to={path} className="btn btn-outline-secondary mb-4 w-100">
      더보기 &gt;
    </Link>
  );
};

export default MoreButton;
